<template>
  <div class="keywords-label"
       v-if="type !== 'permissions' || RMTPermission"
  >
    {{ type }}
  </div>
  <div class="keywords-holder">
    <KeywordOption
      v-for="(option, index) in getSelectorType"
      :key="type + option"
      :option="option"
      :removable="true"
      :type="type"
      :class="checkRMTState"
      @click="handleKeywordClick(option, index)"
    />
  </div>
  <div ref="inputHolder" class="input-tag-matrix-holder">
    <div class="input-holder">
        <TagMatrix
          v-if="matrixVisibility"
          ref="tagMatrix"
          :tag-data="tagData"
          :type="type"
          @hide-matrix="handleHideMatrix"
        />
      </div>
      <input
        ref="searchInput"
        v-model="keywordSearchText"
        type="text"
        class="keyword-dropdown"
        :placeholder="getInputLabel"
        @input="handleKeywordSearch"
        @focusin="handleFocusIn"
        @focusout="handleFocusOut"
        v-if="RMTPermission"
      >
      <div
        class="tag-matrix-btn"
        @click="handleTagMatrix"
        v-if="RMTPermission && !RMTStore.inMultiSelectionMode"
      >
        <div class="tag-matrix-icon-holder">
          <img
            :src="require('@/assets/svg/SVG/tag_matrix.svg')"
            class="tag-matrix-icon"
            alt="Download"
          >
        </div>
        <div class="tag-text">
          {{ getMatrixLabel }}
        </div>
      </div>
    </div>
  <div ref="optionsHolder" id="optionsHolder" class="options-holder">
    <!-- v-if="isFocused" is causing some issues with selecting keywords -->
    <!-- v-if="isFocused" to be replaced in the div below -->
    <div
      v-if="isFocused"
      ref="keywordAutocompleteHolder"
      class="keyword-autocomplete-holder"
      @mousedown.prevent="handleOptionMouseDown"
    >
      <div
        v-show="getMatchingOptions.length === 0"
        class="recent"
      >
        No results found. <span
          v-if="this.$props.type === 'tags'"
          class="textCreateATag"
          @click="handleTagMatrix"
        >Create a tag.</span>
      </div>
      <div
        v-show="getMatchingOptions.length > 0"
        ref="keywordAutocomplete"
        class="keyword-autocomplete"
      >
        <KeywordOption
          v-for="(option, index) in getMatchingOptions"
          :key="index"
          :option="option"
          :removable="false"
          :type="type"
          :keyword="true"
          @mouseup.prevent="handleOptionAdd(option)"
          @mousedown.prevent="handleOptionMouseDown"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { useRMTStore } from '@/store/RMTStore';
import KeywordOption from '@/components/rmt/KeywordOption';
import { mapStores } from 'pinia';
import TagMatrix from '@/components/rmt/tag_matrix/TagMatrix';
import { storeToRefs } from 'pinia/dist/pinia';
import { nextTick } from 'vue';
import { useCollectionStore } from '@/store/CollectionStore';

export default {
  name: 'KeywordSelector',
  components: { TagMatrix, KeywordOption },
  props: [
    'type'
  ],
  watch: {
    getSelectedUploadedFileData (to, from) {
      if (to !== from) {
        return this.getSelectorType;
      } else if (to.tagIds !== from.tagIds) {
        return this.getSelectorType;
      }
    }
  },
  data () {
    return {
      keywordSearchText: '',
      matrixVisibility: false,
      isFocused: false,
      optionEnter: false,
    };
  },
  setup () {
    const RMTStore = useRMTStore();
    const { RMTPermission } = storeToRefs(RMTStore);
    return {
      RMTStore, RMTPermission
    };
  },
  mounted () {


  },
  computed: {
    ...mapStores(useRMTStore),
    getSelectedUploadedFileData () {
      const RMTStore = useRMTStore();
      return RMTStore.getSelectedUploadedFileData;
    },
    getMatrixLabel () {
      switch (this.$props.type) {
        case 'tags':
          return 'Show All Tags';
        case 'collections':
          return 'Show All Collections';
        case 'permissions':
          return 'Show All Permissions';
        default:
          return '';
      }
    },
    getInputLabel () {
      switch (this.$props.type) {
        case 'tags':
          return 'enter tag keywords';
        case 'collections':
          return 'enter collection keywords';
        case 'permissions':
          return 'enter permission keywords';
        default:
          return '';
      }
    },
    getSelectorType () {
      return this.RMTStore.getAssociationsById(this.$props.type);
    },
    getMatchingOptions () {
      return this.RMTStore.getMatchingAssociations(this.$props.type);
    },
    // todo: update for tag matrix
    tagData () {
      switch (this.$props.type) {
        case 'tags':
          // eslint-disable-next-line no-case-declarations
          const RMTStore = useRMTStore();
          return RMTStore.getTagData;
        case 'collections':
          // eslint-disable-next-line no-case-declarations
          const collectionStore = useCollectionStore();
          return collectionStore.collections;
        case 'permissions':
          // eslint-disable-next-line no-case-declarations
          const permissionStore = useCollectionStore();
          return permissionStore.permissionData;
      }
    },
    checkRMTState () {
      return (!this.RMTPermission) ? 'rmt-disable-keyword' : '';
    }
  },
  methods: {
    async handleFocusIn () {
      this.isFocused = true;
      this.matrixVisibility = false;
      await nextTick();
      let optionsHolder = this.$refs.optionsHolder;
      let rmtRight = document.getElementById('rmtRight');
      rmtRight.prepend(optionsHolder);
      let rightHolder = document.getElementById('rightHolder');
      let scrollTop = rightHolder.scrollTop;
      let elementOffset = this.$refs.inputHolder.offsetTop;
      let h = this.$refs.keywordAutocompleteHolder.clientHeight / 2;
      this.$refs.keywordAutocompleteHolder.style.top = (elementOffset - h - scrollTop + 15) + 'px';
    },
    handleFocusOut () {
      this.isFocused = false;
    },
    handleKeywordSearch () {
      this.RMTStore.setString(this.$props.type, this.keywordSearchText);
    },
    handleKeywordClick () {
      // DO NOT DELETE -- this triggers KeywordSelector to redraw
    },
    handleOptionAdd (option) {
      this.RMTStore.addKeywordToSelection(option, this.$props.type);
    },

    // TODO : update tag matrix for multiple selection
    async handleTagMatrix () {
      if (!this.matrixVisibility) {
        this.matrixVisibility = true;
        await nextTick();
        let matrix = this.$refs.tagMatrix;
        let rmtRight = document.getElementById('rmtRight');
        rmtRight.prepend(matrix.$el);
        
        // disable clicks on rightHolder
        let rightHolder = document.getElementById('rightHolder');
        rightHolder.style.pointerEvents = 'none';
        rightHolder.style.opacity = '.5';

        if (this.$props.type === 'tags') {
          this.RMTStore.resetCreateTag();
          this.RMTStore.matrixMode = 'show';
          this.RMTStore.showAddGroup = false;
          this.matrixVisibility = true;
          this.isFocused = false;
        }
      } else {
        this.handleHideMatrix();
      }
    },
    handleHideMatrix () {
      this.matrixVisibility = false;
      let rightHolder = document.getElementById('rightHolder');
      rightHolder.style.pointerEvents = 'auto';
      rightHolder.style.opacity = '1';
    },
    handleOptionMouseDown () {
      this.$refs.searchInput.focus();
    }
  },
};
</script>

<style>
.keywords-label {
  text-transform: uppercase;
  font-size: .75em;
  font-weight: 900;
  letter-spacing: .05em;
  padding-top: 20px;
  padding-bottom: 5px;
}
.input-tag-matrix-holder {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
</style>

<style scoped>
.options-holder {
  max-height: 450px;
}
.keyword-dropdown {
  width: 100%;
  height: 30px;
  border-radius: 20px;
  padding-left: 10px;
  font-size: .75em;
  background-color: white;
}
.keyword-autocomplete-holder {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
  border: 1px solid whitesmoke;
  background-color: white;
  transform: translateX(-100%) translateY(0%);
  position: absolute;
  -webkit-box-shadow: 6px 6px 17px -2px rgba(0, 0, 0, 0.18);
  -moz-box-shadow: 6px 6px 17px -2px rgba(0, 0, 0, 0.18);
  box-shadow: 6px 6px 17px -2px rgba(0, 0, 0, 0.18);
}
.keywords-holder {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 10px;
}
.recent {
  font-size: .85em;
  padding-left: 10px;
  padding-right: 10px;
}
.keyword-autocomplete {
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  max-height: 500px;
}
.input-holder {
  display: flex;
  cursor: pointer;
}
.tag-matrix-icon {
  width: 18px;
  height: 18px;
}
.tag-matrix-icon-holder {
  width: 18px;
  height: 18px;
  margin-left: 10px;
}
.tag-text {
  margin-left: 10px;
  font-size: .75em;
}
.tag-matrix-btn {
  max-width: 200px;
  margin-top:10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.recent {
  color: #939393;
  font-size: .75em;
  padding: 10px;
}
.textCreateATag {
  color: black;
  font-weight: bold;
  cursor: pointer;
}
.rmt-disable-keyword {
  pointer-events: none;
  cursor: default;
}
</style>